import React, { useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CommentSection = ({ postId, comments, onCommentAdded }) => {
  const [commentForm, setCommentForm] = useState({
    author_name: '',
    author_email: '',
    content: ''
  });
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleCommentSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/blog/posts/${postId}/comments`, commentForm);
      setSubmitStatus({ type: 'success', message: 'Comment submitted for approval!' });
      setCommentForm({ author_name: '', author_email: '', content: '' });
      setTimeout(() => setSubmitStatus(null), 5000);
      if (onCommentAdded) onCommentAdded();
    } catch (error) {
      setSubmitStatus({ type: 'error', message: 'Failed to submit comment' });
    }
  };

  return (
    <div className="border-t pt-8 mt-8">
      <h2 className="font-rubik text-2xl font-bold mb-6 text-[#aaae10] uppercase">
        Comments ({comments.length})
      </h2>

      <div className="space-y-6 mb-8">
        {comments.map((comment) => (
          <div key={comment.id} className="bg-gray-50 p-4 rounded-lg">
            <div className="flex justify-between items-start mb-2">
              <h3 className="font-rubik font-bold text-[#646464]">{comment.author_name}</h3>
              <span className="text-sm text-gray-500">
                {new Date(comment.created_at).toLocaleDateString()}
              </span>
            </div>
            <p className="font-roboto text-gray-700">{comment.content}</p>
          </div>
        ))}
        {comments.length === 0 && (
          <p className="text-gray-500 text-center py-4">No comments yet. Be the first to comment!</p>
        )}
      </div>

      <div className="bg-gray-50 p-6 rounded-lg">
        <h3 className="font-rubik text-xl font-bold mb-4 text-[#646464] uppercase">
          Leave a Comment
        </h3>
        <form onSubmit={handleCommentSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <input
              type="text"
              placeholder="Your Name *"
              value={commentForm.author_name}
              onChange={(e) => setCommentForm({ ...commentForm, author_name: e.target.value })}
              required
              className="px-4 py-2 border rounded font-roboto"
            />
            <input
              type="email"
              placeholder="Your Email *"
              value={commentForm.author_email}
              onChange={(e) => setCommentForm({ ...commentForm, author_email: e.target.value })}
              required
              className="px-4 py-2 border rounded font-roboto"
            />
          </div>
          <textarea
            placeholder="Your Comment *"
            value={commentForm.content}
            onChange={(e) => setCommentForm({ ...commentForm, content: e.target.value })}
            required
            rows="4"
            className="w-full px-4 py-2 border rounded font-roboto mb-4"
          ></textarea>
          {submitStatus && (
            <div className={`mb-4 p-3 rounded ${submitStatus.type === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
              {submitStatus.message}
            </div>
          )}
          <button type="submit" className="btn-primary">
            Submit Comment
          </button>
        </form>
      </div>
    </div>
  );
};

export default CommentSection;
